export default __webpack_public_path__ + "static/media/mountains.2540b713.jpg";